export const ALLOWED_COMARR_COMPANY_IDS = new Set([1, 129, 141, 144]);
